import { TmFormError } from '@/core/error/tmFormError'

export class TmFormInvalidUsageError extends TmFormError {
  public name = 'TmFormInvalidUsageError'
}
